import React from 'react';
import { IAmountFormatProps } from './AmountFormat.types';

const baseFormatParams: Record<string, any> = {
  style: 'decimal',
  useGrouping: true,
  roundingMode: 'trunc',
};

function buildIntegerFormatter(decimals: number) {
  return Intl.NumberFormat('en', {
    ...baseFormatParams,
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  });
}

export const numberFormatInteger = buildIntegerFormatter(0);

export const numberFormat2Decimals = buildIntegerFormatter(2);

export const numberFormat4Decimals = buildIntegerFormatter(4);

export const numberFormat10Decimals = buildIntegerFormatter(10);

export const AmountFormat: React.FC<IAmountFormatProps> = ({ amount, decimals, currency }: IAmountFormatProps) => {
  let format;
  switch (decimals) {
    case undefined:
    case 2:
      format = numberFormat2Decimals;
      break;
    case 0:
      format = numberFormatInteger;
      break;
    case 4:
      format = numberFormat4Decimals;
      break;
    case 10:
      format = numberFormat10Decimals;
      break;
    default:
      format = buildIntegerFormatter(decimals);
  }

    return <>{currency ? `${currency} ${format.format(amount)}` : format.format(amount)}</>;
};
